module.exports = __webpack_public_path__ + "img/about.63a86b99.png";